'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.provider('PensionModulesStore', function(StoreTemplate) {
  var modules = [];

  var template = StoreTemplate.extend({
    initFn: function() {
    },
    getterFns: {
      getModules: function() {
        return modules;
      }
    },
    dispatcherListeners: {
      'pensionModulesService:modulesLoaded': function(payload) {
        modules = payload;
      },
      'pensionModulesService:clearModules': function() {
        modules = [];
      }
    }
  });

  return template;
});
